module.exports = __webpack_public_path__ + "static/media/112.43457e95.jpg";